import { cn } from '@/lib/utils';
import {
  TransactionBuilderParameterInputProps,
  TransactionBuilderParameterState,
} from './types';
import { getParameterStateForBoolean } from './utils';
import { getReadableSolidityName } from '@/lib/solidity-formatting';

export function BooleanInput({
  value,
  name,
  onChange,
  paramAbiFragment,
}: TransactionBuilderParameterInputProps): React.ReactElement {
  const label = getReadableSolidityName(
    paramAbiFragment.name || name,
    'Parameter'
  );
  const active = value === 'true' ? 'true' : value === 'false' ? 'false' : '';

  const handleSelect = (
    event: React.MouseEvent<HTMLButtonElement>,
    val: 'true' | 'false' | undefined
  ) => {
    // Case: user tried to deselect
    // Prevent deselecting the active option (match den-ui behavior)
    if (!val) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    // Update form state
    const newState: TransactionBuilderParameterState =
      getParameterStateForBoolean(val);
    // Call `onChange` callback
    onChange?.(name, newState);
  };

  return (
    <div className="flex w-full rounded-[12px] border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-950 overflow-hidden">
      <div className="flex items-center px-3 py-2 text-sm font-medium text-zinc-700 dark:text-zinc-200 border-r border-zinc-200 dark:border-zinc-800 min-w-[120px]">
        {label}
      </div>
      <div className="flex flex-1 items-center justify-end gap-2 px-2 py-1">
        {(['true', 'false'] as const).map((option) => {
          const isActive = active === option;
          return (
            <button
              key={option}
              type="button"
              onClick={(e) => handleSelect(e, option)}
              className={cn(
                'px-4 py-2 text-sm font-medium transition-colors rounded-[10px]',
                isActive
                  ? 'bg-zinc-900 text-white dark:bg-white dark:text-zinc-900 shadow-sm'
                  : 'text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-900'
              )}
            >
              {option === 'true' ? 'True' : 'False'}
            </button>
          );
        })}
      </div>
    </div>
  );
}
